import {
    CANDI_WORK_PREFERENCE_REQUEST,
    CANDI_WORK_PREFERENCE_SUCCESS,
    CANDI_WORK_PREFERENCE_FAIL,
} from "../constants/AuthConstant";

import axios from "axios";
// import { toast } from "react-toastify";

export const CandidateWorkPreferenceAction = (id) => {
    return function (dispatch) {
      dispatch({
        type: CANDI_WORK_PREFERENCE_REQUEST,
        payload: true,
      });
     
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/work_preference/get_work_preference_by_candidateId?candidateId=${id}`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };

      axios(OPTION)
        .then((res) => {
          dispatch(CandiWorkPreferencePre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: CANDI_WORK_PREFERENCE_FAIL,
            payload: false,
            error: error,
          });
          // toast.error("Failed to load the information");
        });
    };
  };
  export const CandiWorkPreferencePre = (data) => {
    return {
      type: CANDI_WORK_PREFERENCE_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };